import { Link } from 'react-router-dom';

const FEATURES = [
  {
    icon: 'ri-brain-line',
    title: 'AIタスク分解',
    description: '企画書やPDFをアップロードするだけで、AIがタスク、担当者、期限、依存関係を自動提案します。',
    path: '/features/ai-task-breakdown/',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    icon: 'ri-bar-chart-horizontal-line',
    title: 'AIガントチャート',
    description: 'タスクの親子関係、依存関係、マイルストーン、予定と実績の比較を自動で表示します。',
    path: '/features/ai-gantt/',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    icon: 'ri-file-text-line',
    title: 'AI日報',
    description: '自由な文章で報告するだけで、AIが進捗を解析し、タスクのステータスを自動更新します。',
    path: '/features/ai-daily-report/',
    color: 'bg-secondary-100 text-secondary-600',
  },
  {
    icon: 'ri-folders-line',
    title: 'AIファイル管理',
    description: 'プロジェクト資料をアップロードすると、AIが内容を読み取り、根拠付きで質問に回答します。',
    path: '/features/ai-file-management/',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    icon: 'ri-team-line',
    title: 'チーム機能',
    description: 'プロジェクト別チャット、タスク別コメント、メンション通知、ファイル共有で情報を一元化します。',
    path: '/features/team-collaboration/',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    icon: 'ri-translate-2',
    title: '多言語・多国祝日',
    description: '日本語・英語・タイ語に対応。メンバーごとの国別祝日を考慮したスケジュールを自動計算します。',
    path: '/features/multilingual/',
    color: 'bg-secondary-100 text-secondary-600',
  },
];

export default function FeatureGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-4">
          AIが整理する6つの機能
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-12">
          ”おもいむすび”は、プロジェクト管理に必要なすべての機能をAIで強化します
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {FEATURES.map((feature) => (
            <Link
              key={feature.title}
              to={feature.path}
              className="group bg-background-50 rounded-lg border border-background-200/70 p-6 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-12 h-12 rounded-lg flex items-center justify-center mb-4 ${feature.color}`}>
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{feature.description}</p>
              <span className="text-sm text-primary-600 font-medium inline-flex items-center gap-1">
                詳しく見る <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}